/**
 * 滚动工具函数
 */

/**
 * 平滑滚动到页面顶部
 * @param {string} behavior - 滚动行为，默认为 'smooth'
 */
export const scrollToTop = (behavior = 'smooth') => {
  // 兼容性检查
  if ('scrollBehavior' in document.documentElement.style) {
    window.scrollTo({
      top: 0,
      behavior
    });
  } else {
    // 兼容老浏览器
    window.scrollTo(0, 0);
  }
};

/**
 * 强制滚动到页面顶部（立即执行，无动画）
 */
export const forceScrollToTop = () => {
  window.scrollTo(0, 0);
};

/**
 * 检查页面是否在顶部
 * @returns {boolean}
 */
export const isAtTop = () => {
  return window.scrollY === 0;
};

/**
 * 滚动到指定元素
 * @param {string|Element} target - 目标元素或选择器
 * @param {Object} options - 滚动选项
 */
export const scrollToElement = (target, options = {}) => {
  const element = typeof target === 'string' ? document.querySelector(target) : target;
  if (element) {
    const defaultOptions = {
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    };
    
    element.scrollIntoView({ ...defaultOptions, ...options });
  }
};

/**
 * 初始化页面置顶功能
 */
export const initScrollToTop = () => {
  // 页面加载完成后置顶
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (!isAtTop()) {
        scrollToTop();
      }
    });
  } else {
    if (!isAtTop()) {
      scrollToTop();
    }
  }
  
  // 监听页面可见性变化，确保页面重新可见时置顶
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && !isAtTop()) {
      scrollToTop();
    }
  });
};
